<template>
  <div class="c--shared_hero w-100">
    <div class="tw-overflow-hidden tw-relative tw-bg-contain" :style="bannerStyle">
      <template v-if="$slots.default">
        <div class="tw-w-full tw-centered-x tw-z-20 tw-top-10 md:tw-top-15" v-if="$slots">
          <slot />
        </div>
      </template>
      <template v-if="$slots.second">
        <slot name="second" />
      </template>

      <div class="tw-w-full tw-h-full tw-relative tw-z-10 tw-flex tw-justify-center">
        <nuxt-img
          :src="url"
          :width="imageWidth"
          :height="imageHeight"
          :alt="altText"
          loading="eager"
          :class="[imageClass, imageHeightClass]"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'static-pages-hero',

    props: {
      url: {
        type: String,
        required: true,
      },

      height: {
        type: [String, Number],
        required: false,
        default: 'auto',
      },

      image: {
        type: Object,
        required: false,
        default: null,
      },

      altText: {
        type: String,
        required: false,
        default: 'Airalo | About Airalo image',
      },

      background: {
        type: String,
        required: false,
        default: '',
      },
    },

    computed: {
      bannerStyle() {
        const style = {
          height: typeof this.height === 'number' ? `${this.height}px` : this.height,
          ...(this.background && this.background.length > 0
            ? {
                background: this.background,
              }
            : {}),
        }
        return style
      },

      imageWidth() {
        return this.image?.width || 1440
      },

      imageHeight() {
        return this.image?.height || 635
      },
      imageHeightClass() {
        return this.image?.height ? `tw-h-[${this.image.height}px]` : 'tw-h-full'
      },
      imageClass() {
        return this.image?.classes || 'tw-object-contain tw-centered-xy'
      },
    },
  }
</script>
